import styled, { css } from 'styled-components';
import { fontSize } from '../../mixins';
import { rem } from 'polished';
import { spin } from '../../mixins/animations';
var spinnerSizing = {
  xl: '72',
  lg: '56',
  md: '40',
  sm: '24',
  xs: '20'
};
export var SpinnerIconContainer = styled.div.withConfig({
  displayName: "Spinnerstyle__SpinnerIconContainer",
  componentId: "sc-11bhmz-0"
})(["", ""], function (_ref) {
  var size = _ref.size;
  var spinnerSize = spinnerSizing[size];
  return "\n      position: relative;\n      width: ".concat(rem(spinnerSize + 'px'), ";\n      height: ").concat(rem(spinnerSize + 'px'), ";\n    ");
});
export function spinnerCSS(_ref2) {
  var theme = _ref2.theme,
      size = _ref2.size,
      darkBg = _ref2.darkBg;
  var spinnerSize = spinnerSizing[size];
  var lineWidth = "".concat(rem(Math.round(spinnerSize / 12) + 'px'));
  var animationSpeed = "".concat(1 + spinnerSize / 100, "s");
  return css(["position:absolute;width:", ";height:", ";border-radius:50%;border-top:3px solid transparent;border-right:3px solid transparent;border-bottom:", " solid ", ";border-left:", " solid ", ";animation:", " ", " infinite linear;"], rem(spinnerSize + 'px'), rem(spinnerSize + 'px'), lineWidth, darkBg ? theme.color.white : theme.color.primary, lineWidth, darkBg ? theme.color.white : theme.color.primary, spin, animationSpeed);
}
export function spinnerBgCSS(_ref3) {
  var theme = _ref3.theme,
      size = _ref3.size,
      darkBg = _ref3.darkBg;
  var spinnerSize = spinnerSizing[size];
  var lineWidth = "".concat(rem(Math.round(spinnerSize / 12) + 'px'));
  return css(["position:absolute;width:", ";height:", ";border-radius:50%;border:", " solid ", ";opacity:", ";"], rem(spinnerSize + 'px'), rem(spinnerSize + 'px'), lineWidth, darkBg ? theme.color.white : theme.color.black, darkBg ? '0.2' : '0.1');
}
export var StyledSpinnerMessage = styled.span.withConfig({
  displayName: "Spinnerstyle__StyledSpinnerMessage",
  componentId: "sc-11bhmz-1"
})(["font-family:", ";", ";color:", ";margin-top:", ";margin-left:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.font.family.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return fontSize(theme.font.size.xs);
}, function (_ref6) {
  var theme = _ref6.theme,
      darkBg = _ref6.darkBg;
  return darkBg ? theme.color.white : theme.color.grey30;
}, function (_ref7) {
  var theme = _ref7.theme,
      inline = _ref7.inline;
  return inline ? null : theme.spaces.sm;
}, function (_ref8) {
  var theme = _ref8.theme,
      inline = _ref8.inline;
  return inline ? theme.spaces.sm : null;
});
export var StyledSpinner = styled.div.withConfig({
  displayName: "Spinnerstyle__StyledSpinner",
  componentId: "sc-11bhmz-2"
})(["", ";"], spinnerCSS);
export var StyledSpinnerBackground = styled.div.withConfig({
  displayName: "Spinnerstyle__StyledSpinnerBackground",
  componentId: "sc-11bhmz-3"
})(["", ";"], spinnerBgCSS);
export var SpinnerContainer = styled.div.withConfig({
  displayName: "Spinnerstyle__SpinnerContainer",
  componentId: "sc-11bhmz-4"
})(["flex:0 1 100%;display:flex;flex-direction:", ";align-items:center;", "{@media screen and (-ms-high-contrast:active){border-style:inset;}}"], function (_ref9) {
  var inline = _ref9.inline;
  return inline ? "row" : "column";
}, StyledSpinner);